(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info-overview"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const popupTriggers = document.querySelectorAll('[data-popup-trigger]');
    let popupOriginalParent = null;
    let popupOriginalNextSibling = null;

    popupTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const popupId = this.getAttribute('data-popup-trigger');
        const popup = document.getElementById(popupId);

        if (popup) {
          // Store original location before moving
          if (popup.parentElement !== document.body) {
            popupOriginalParent = popup.parentElement;
            popupOriginalNextSibling = popup.nextSibling;
            document.body.appendChild(popup);
          }

          popup.style.display = 'flex';
          popup.setAttribute('aria-hidden', 'false');
          document.body.classList.add('popup-open');

          // Focus trap
          const closeBtn = popup.querySelector('[data-popup-close]');
          if (closeBtn) {
            closeBtn.focus();
          }
        }
      });
    });

    // Function to close popup
    function closePopup(popup) {
      if (popup) {
        popup.style.display = 'none';
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('popup-open');

        // Move popup back to original location
        if (popupOriginalParent) {
          if (popupOriginalNextSibling) {
            popupOriginalParent.insertBefore(popup, popupOriginalNextSibling);
          } else {
            popupOriginalParent.appendChild(popup);
          }
        }
      }
    }

    // Close popup on button click
    document.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-popup-close') || e.target.closest('[data-popup-close]')) {
        e.preventDefault();
        const popup = e.target.closest('.popup-modal');
        closePopup(popup);
      }
    });

    // Close on ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const openPopup = document.querySelector('.popup-modal[aria-hidden="false"]');
        closePopup(openPopup);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sample-product-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    function waitForDependencies(callback) {
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        callback();
      } else {
        setTimeout(() => waitForDependencies(callback), 50);
      }
    }

    class SampleProductPopup {
      constructor(modalId) {
        this.modal = document.querySelector(modalId);
        if (!this.modal) return;

        this.wrapper = this.modal.querySelector('.sample-product-popup__wrapper');
        this.mediaContainer = this.modal.querySelector('[id^="SampleProductMedia"]');
        this.variantSelects = this.modal.querySelector('variant-selects');
        this.sectionId = this.variantSelects?.dataset.section;

        // Get the main product section ID from the page
        const mainProductInfo = document.querySelector('product-info[data-section]');
        this.mainSectionId = mainProductInfo?.dataset.section || this.sectionId;

        this.productUrl = this.wrapper?.dataset.productUrl || window.location.pathname;
        this.abortController = null;
        this.unsubscriber = null;
        this.productForm = this.modal.querySelector('form[data-type="add-to-cart-form"]');
        this.variantIdInput = this.productForm?.querySelector('input.product-variant-id, input[name="id"]');

        // Parse product variants from data attribute
        try {
          const variantsJson = this.wrapper?.dataset.productVariants;
          if (variantsJson) {
            this.productVariants = JSON.parse(variantsJson);
          }
        } catch (e) {
          this.productVariants = [];
        }

        if (this.variantSelects && this.mediaContainer && this.sectionId) {
          waitForDependencies(() => {
            // Listen to variant-change event (published by product-info after update)
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
              // Check if this is from our popup's product-info
              const popupProductInfo = this.modal.querySelector('product-info');
              if (event?.data?.variant && popupProductInfo && event.data.sectionId === this.sectionId) {
                this.updateMediaForVariant(event.data.variant);
              }
            });

            // Also listen to option value selection change as backup
            this.unsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
              if (event?.data?.event?.target && this.modal.contains(event.data.event.target)) {
                // Wait for product-info to update variant data
                setTimeout(() => {
                  this.handleVariantChangeDirect();
                }, 300);
              }
            });

            // Listen to cart update event to close modal after successful add to cart
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
              // Check if this cart update is from our popup's product form
              const popupProductForm = this.modal.querySelector('product-form');
              if (event?.source === 'product-form' && popupProductForm && this.modal.contains(popupProductForm)) {
                // Close the modal after a short delay to allow cart notification to show
                setTimeout(() => {
                  const modalDialog = this.modal.closest('modal-dialog');
                  if (modalDialog && typeof modalDialog.hide === 'function') {
                    modalDialog.hide();
                  }
                }, 300);
              }
            });
          });
        }
      }

      handleVariantChangeDirect() {
        if (!this.variantSelects || !this.mediaContainer) return;

        // Get actual selected option values (not IDs) from inputs/selects
        const selectedOptions = [];

        // Get all selects and radio inputs
        const selects = this.variantSelects.querySelectorAll('select');
        const radioInputs = this.variantSelects.querySelectorAll('fieldset input[type="radio"]:checked');

        // Get values from selects
        selects.forEach((select) => {
          if (select.selectedOptions && select.selectedOptions.length > 0) {
            selectedOptions.push(select.selectedOptions[0].value);
          }
        });

        // Get values from radio inputs
        radioInputs.forEach((input) => {
          selectedOptions.push(input.value);
        });

        if (selectedOptions.length === 0) {
          return;
        }

        // Find matching variant from product variants
        const matchingVariant = this.findVariantByOptions(selectedOptions);

        if (matchingVariant) {
          this.updateMediaForVariant(matchingVariant);
        } else {
          // Fallback: try to get from data-selected-variant
          const selectedVariantData = this.variantSelects.querySelector('[data-selected-variant]');
          if (selectedVariantData) {
            try {
              const variant = JSON.parse(selectedVariantData.textContent);
              this.updateMediaForVariant(variant);
            } catch (e) {
              // Error parsing variant data
            }
          }
        }
      }

      findVariantByOptions(selectedOptions) {
        if (!this.productVariants || !Array.isArray(this.productVariants)) {
          return null;
        }

        // Find variant that matches all selected option values
        return this.productVariants.find((variant) => {
          const option1Match = !selectedOptions[0] || variant.option1 === selectedOptions[0];
          const option2Match = !selectedOptions[1] || variant.option2 === selectedOptions[1];
          const option3Match = !selectedOptions[2] || variant.option3 === selectedOptions[2];

          return option1Match && option2Match && option3Match;
        });
      }

      handleVariantChange(selectedOptionValues) {
        if (!this.variantSelects || !this.mediaContainer || !this.sectionId || !this.productUrl) return;

        // Abort previous request if it exists
        if (this.abortController) {
          this.abortController.abort();
        }

        // Create new abort controller for this request
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        const params = new URLSearchParams();
        // Use main section ID for fetching product data
        params.append('section_id', this.mainSectionId);
        if (selectedOptionValues && selectedOptionValues.length) {
          params.append('option_values', selectedOptionValues.join(','));
        }

        const requestUrl = `${this.productUrl}?${params.toString()}`;

        fetch(requestUrl, { signal })
          .then((response) => {
            if (signal.aborted) return;
            if (!response.ok) throw new Error('Network response was not ok');
            return response.text();
          })
          .then((responseText) => {
            if (signal.aborted) return;

            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const productInfo = html.querySelector('product-info');

            if (productInfo) {
              const variant = this.getSelectedVariant(productInfo);
              if (variant) {
                this.updateMediaForVariant(variant);
              }
            }
          })
          .catch((error) => {
            // Silently ignore AbortError - it's expected when user changes variant quickly
            if (error.name === 'AbortError') {
              return;
            }
          });
      }

      updateMediaForVariant(variant) {
        if (!variant || !this.mediaContainer) return;

        // Update variant ID in the form
        this.updateVariantId(variant.id);

        // Remove active class from all media items first
        this.mediaContainer.querySelectorAll('.sample-product-popup__media-item').forEach((item) => {
          item.classList.remove('is-active');
        });

        let activeMediaItem = null;

        // Try to find by variant ID first
        if (variant.id) {
          activeMediaItem = this.mediaContainer.querySelector(`[data-variant-id="${variant.id}"]`);
        }

        // Fallback: try to find by featured media ID
        if (!activeMediaItem && variant.featured_media?.id) {
          activeMediaItem = this.mediaContainer.querySelector(`[data-variant-media-id="${variant.featured_media.id}"]`);
        }

        // If found, activate it
        if (activeMediaItem) {
          activeMediaItem.classList.add('is-active');
        }
      }

      updateVariantId(variantId) {
        if (!variantId) return;

        // Update the hidden input field
        if (this.variantIdInput) {
          this.variantIdInput.value = variantId;
          this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          // Try to find it again in case it wasn't available during initialization
          this.variantIdInput = this.modal.querySelector('input.product-variant-id, input[name="id"]');
          if (this.variantIdInput) {
            this.variantIdInput.value = variantId;
            this.variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      disconnectedCallback() {
        this.unsubscriber?.();
        this.variantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
        this.abortController?.abort();
      }
    }

    function initSampleProductPopups() {
      document.querySelectorAll('[id^="SampleProductModal-"]').forEach((modal) => {
        new SampleProductPopup('#' + modal.id);
      });
    }

    function initSampleProductPopups() {
      document.querySelectorAll('[id^="SampleProductModal-"]').forEach((modal) => {
        new SampleProductPopup('#' + modal.id);

        // Fix data-section-id for product-form in popup
        const productForm = modal.querySelector('product-form');
        if (productForm && !productForm.dataset.sectionId) {
          const sectionId = modal.querySelector('.sample-product-popup__wrapper')?.dataset?.productUrl
            ? modal.id.replace('SampleProductModal-', '')
            : null;
          if (sectionId) {
            productForm.setAttribute('data-section-id', sectionId);
          }
        }

        // Ensure buttons are visible
        const buttons = modal.querySelectorAll('.product-form__submit, .product-form__buttons');
        buttons.forEach((btn) => {
          btn.style.display = 'block';
          btn.style.visibility = 'visible';
          btn.style.opacity = '1';
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSampleProductPopups);
    } else {
      initSampleProductPopups();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
